<template>
  <ul class="list-group">
    <li class="list-group-item minpadding fw-bold onepadding bg-grad-orange">
      Teams progress
    </li>
    <li
      class="list-group-item minpadding bg-grad-orange"
      v-for="t in sorted_teams"
      :key="t.id"
    >
      <div class="row d-flex align-items-center midtxt">
        <div class="col">
          <i
            class="bi bi-circle-fill text-primary float-start"
            v-if="t.bid_email == store.user.email"
          ></i>
          {{ t.name }}
        </div>
        <div class="col-6"><TeamReport :team_id="t.id"></TeamReport></div>
        <div class="col">{{ formatToIndianCurrency(t.wallet) }}</div>
        <div class="col">
          <i
            class="bi bi-chevron-double-down float-end text-primary"
            v-if="expand_team != t.id"
            @click="expandThis(t.id)"
          ></i>
          <i
            class="bi bi-chevron-double-up float-end text-danger"
            v-else
            @click="expandThis(t.id)"
          ></i>
        </div>
      </div>
      <div class="row" v-if="t.id == expand_team">
        <div class="col"><IndividualTeam :team_id="t.id"></IndividualTeam></div>
      </div>
    </li>
  </ul>
</template>
<script setup>
import { useStore } from "@/store/index";
import { onMounted, ref, computed } from "vue";
import supabase from "@/supabase/config";
import IndividualTeam from "./IndividualTeam.vue";
import TeamReport from "./TeamReport.vue";
const store = useStore();
const all_teams = ref([]);
const expand_team = ref("");
const expandThis = (id) => {
  if (expand_team.value != id) {
    expand_team.value = id;
  } else {
    expand_team.value = "";
  }
};
onMounted(() => {
  fetchTeams();
  setupListner();
});
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
  setupListner();
};
const sorted_teams = computed(() => {
  var arr = [];
  all_teams.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.wallet - a.wallet);

  return sorted_arr;
});
const setupListner = () => {
  const channels = supabase
    .channel("bidder-teams-status-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "teams",
        filter: `auction_id=eq.${store.live_auction}`,
      },
      (payload) => {
        all_teams.value = [];
        fetchTeams();
        //console.log("Change received!", payload);
      }
    )
    .subscribe();
};
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
</script>
<style scoped>
.midtxt {
  font-size: 12px;
}
.minpadding {
  padding: 5px;
}
</style>
